import { render } from "./Splash.vue?vue&type=template&id=d8a2182c&scoped=true&ts=true"
import script from "./Splash.vue?vue&type=script&lang=ts"
export * from "./Splash.vue?vue&type=script&lang=ts"

import "./Splash.vue?vue&type=style&index=0&id=d8a2182c&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d8a2182c"]])

export default __exports__